import React from 'react'
import styled from 'styled-components'

import { Currency } from '../../sdk'
import CurrencyLogo from '../CurrencyLogo'

const Wrapper = styled.div<{ margin: boolean; sizeraw: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
`

const SeparatedWrapper = styled.div<{ margin: boolean; sizeraw: number; gap: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ gap }) => gap}px;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
`

interface DoubleCurrencyLogoProps {
  margin?: boolean
  size?: number
  currency0?: Currency
  currency1?: Currency
  /** stacked: monedas superpuestas (legacy). separated: ambas visibles lado a lado. */
  layout?: 'stacked' | 'separated'
}

const HigherLogo = styled(CurrencyLogo)`
  z-index: 2;
`
const CoveredLogo = styled(CurrencyLogo)<{ sizeraw: number }>`
  position: absolute;
  left: ${({ sizeraw }) => (sizeraw / 2).toString() + 'px'};
`

export default function DoubleCurrencyLogo({
  currency0,
  currency1,
  size = 16,
  margin = false,
  layout = 'stacked',
}: DoubleCurrencyLogoProps) {
  const logoSize = size.toString() + 'px'

  if (layout === 'separated') {
    return (
      <SeparatedWrapper sizeraw={size} margin={margin} gap={Math.max(4, Math.round(size / 5))}>
        {currency0 ? <CurrencyLogo currency={currency0} size={logoSize} /> : null}
        {currency1 ? <CurrencyLogo currency={currency1} size={logoSize} /> : null}
      </SeparatedWrapper>
    )
  }

  return (
    <Wrapper sizeraw={size} margin={margin}>
      {currency0 && <HigherLogo currency={currency0} size={logoSize} />}
      {currency1 && <CoveredLogo currency={currency1} size={logoSize} sizeraw={size} />}
    </Wrapper>
  )
}
